import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/pages/MainPage'
// import LoginPage from '@/pages/LoginPage'
// const LoginPage = () => import('../pages/LoginPage')
// TODO Azure登陆
import LoginPage from '@/pages/LoginPageAzure'
import ForgetPasswordPage from '@/pages/ForgetPasswordPage'
import NotFoundPage from '@/pages/404'

Vue.use(Router)

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  // HTML5 History模式(H5+APP不支持)
  mode: 'history',
  // 路由设定
  routes: [
    // 默认页面
    {
      path: '/',
      component: LoginPage,
    },
    // TODO Azure登录 发布时 注掉登录页面
    // 登录页面
    // {
    //   path: '/login',
    //   component: LoginPage,
    // },
    // 忘记密码页面
    // {
    //   path: '/forget',
    //   component: ForgetPasswordPage,
    // },
    // 强制变更密码
    // {
    //   path: '/changePassword',
    //   component: ForcePasswordChange,
    // },
    // 登录页面
    {
      path: '/login/:group_id/:page_id',
      component: LoginPage,
    },

    // 默认页面(分站点)
    {
      path: '/:site_id',
      component: MainPage,
    },
    // 登录页面(分站点)
    {
      path: '/login/:site_id',
      component: LoginPage,
    },
    // 登录页面(分站点)
    {
      path: '/login/:site_id/:group_id/:page_id',
      component: LoginPage,
    },

    // 主页面
    {
      path: '/:group_id/:page_id',
      component: MainPage,
    },
    // 主页面(分站点)
    {
      path: '/:site_id/:group_id/:page_id',
      component: MainPage,
    },

    // 非法请求
    {
      path: '*',
      component: NotFoundPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js